var getRenderProperties = {};
export {
  getRenderProperties as __exports
};
//# sourceMappingURL=index147.js.map
